import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import StoreOrderTable from '../stores/StoreOrderTable';
import StoreOrderViews from '../orders/StoreOrderViews';

const AdminOrderViews = () => (
  <Routes>
    <Route
      element={<StoreOrderViews baseUrl="/merchant/orders" />}
      path="/:pkEcomOrder/*"
    />
    <Route element={<StoreOrderTable isAdminView />} path="/" />
    <Route element={<Navigate replace to="/merchant/orders" />} path="*" />
  </Routes>
);

export default AdminOrderViews;
